import React, { useMemo } from 'react';

import DataTableOrigin from 'components/DataTable';
import { useScreenDispatch, useScreenState } from 'components/Screen';
import {
  LIMIT,
  OFFSET,
  ORDER_BY,
  ORDER_DIR,
  TABLE_SETTINGS,
} from 'scenes/PerformancePage/constants';
import { SET_TABLE_SETTINGS } from 'scenes/PerformancePage/screenReducer';

import Cells from './Cells';
import './index.css';

const DataTable = ({ data, isRefetching }: any) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const columns = useMemo(() => {
    return data?.columns?.map((column: any, index: any) => {
      return {
        accessorKey: `${index}`,
        header: column,
        cell: (info: any) => {
          return (
            <Cells cellData={info?.getValue()} metricType={column.metricType} />
          );
        },
      };
    });
  }, [data?.columns, data?.summaryRow]);

  const handleChangeSort = (column: string) => () => {
    const payload = {
      ...screenState[TABLE_SETTINGS],
      [ORDER_BY]: column,
    };
    if (screenState[TABLE_SETTINGS][ORDER_BY] === column) {
      payload[ORDER_DIR] = payload[ORDER_DIR] === 'desc' ? 'asc' : 'desc';
    } else {
      payload[ORDER_DIR] = 'desc';
    }

    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: payload,
    });
  };

  const handleChangePagination = (_: any, { limit, offset }: any) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: {
        ...screenState[TABLE_SETTINGS],
        [LIMIT]: limit,
        [OFFSET]: offset,
      },
    });
  };

  return (
    <DataTableOrigin
      className={'PerformanceDataTable'}
      columns={columns}
      data={[data.summaryRow, ...data.rows]}
      paging={data.paging}
      isRefetching={isRefetching}
      sticky={true}
      firstRowSummary={true}
      onChangePagination={handleChangePagination}
      onChangeSort={handleChangeSort}
      tableSettings={screenState[TABLE_SETTINGS]}
    />
  );
};
export default DataTable;
